import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  StyledImageGrid,
  ConcludeContainer,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function RyllMesse() {
  const ProjectBG = require("../../../../assets/videos/ryllmesse/poster.png");
  const T1 = require("../../../../assets/videos/ryllmesse/t1.png");
  const R1 = require("../../../../assets/videos/ryllmesse/HoloLens-Multiuser-L.jpg");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="Ryll Messe — multi-user HoloLens for expos"
      lead={
        <p>
          A mixed-reality app for Ryll&apos;s trade-fair presentations: multiple
          visitors join one session and share the same 3D model in the room for
          collaborative, spatial interaction.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/ryllmesse/1_Rylle+Messe.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Simultaneous viewing</WorkSectionHeading>
          <p>
            Several users join one session to view and discuss the model in
            realtime.
          </p>
          <WorkSectionHeading>Innovative design</WorkSectionHeading>
          <p>
            Forward-looking UX keeps advanced spatial tech approachable on the
            show floor.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <StyledImageGrid src={R1} alt="" />
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Collaborative interaction</WorkSectionHeading>
          <p>
            Manipulate and explore the model together—supporting teamwork and
            knowledge sharing.
          </p>
          <WorkSectionHeading>Multiple scenarios</WorkSectionHeading>
          <p>
            Three use cases expose different scenes and models so visitors see
            breadth in one demo.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <ConcludeContainer>
        <p>
          Ryll Messe turns expo presentations into shared, immersive 3D
          experiences—stronger collaboration and clearer storytelling on site.
        </p>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "Ryll Messe" },
          { label: "Period", value: "12.2019 - 02.2020" },
          { label: "Client", value: "RyllMesse" },
          {
            label: "Engine & Tools",
            value: "Unity, Azure Spatial Anchors, C#",
          },
          { label: "Platform", value: "Hololens" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "MR, Multi-User" },
        ]}
      />
    </WorkProjectShell>
  );
}
